import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/boxie24.webp';
import screenshot_target from '../../../images/letterfunnel/gerritjanreinders.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Gerrit Jan Reinders"
      firstname="Gerrit Jan"
      companyname="Boxie24"
      competition="Inbox Storage en Stackt"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/gerritjanreinders.js